import axiosInstance from "./axiosInstance";

export const getAllFaqs = async () => {
  try {
    const response = await axiosInstance.get("/public/faq", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch FAQs");
  }
};

export const getFaqById = async (id) => {
  try {
    const response = await axiosInstance.get(`/faqfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch FAQ");
  }
};

export const createFaq = async (formData) => {
  try {
    const response = await axiosInstance.post("/faq", formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create FAQ");
  }
};

export const updateFaq = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/faq/${id}`, formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update FAQ");
  }
};

export const deleteFaq = async (id) => {
  try {
    const response = await axiosInstance.delete(`/faqdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete FAQ");
  }
};